import { IGlobalPartnerDetails } from '../../../models/globalPartnerDetails'

export const getDataForCompletenessGlobalChart = (data: IGlobalPartnerDetails[]) => {
  const listedData = data.filter((it) => it.IsForCalc)
  return listedData.filter((el) => el.IsPlanRequired)
}
